<template>
  <div>
    <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center">
      <!-- Mask -->
      <span class="mask bg-gradient-warning opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid d-flex align-items-center">
        <div class="row">
          <div class="col-lg-7 col-md-10">
            <p class="text-white mt-3 mb-5">
              Aqui você poderá definir as métricas básicas do fundo. Ao definir
              algum valor ele ficaria visível para os investidores vinculados ao
              fundo.
            </p>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--8">
      <div class="row mb-4">
        <div class="col-12">
          <card shadow footerClasses="pt-2 pb-3 text-center">
            <div slot="header" class="bg-white border-0">
              <div class="row align-items-center">
                <div class="col-8">
                  <h3 class="mb-0">
                    Fundo de Investimentos
                    <span class="text-warning">STARS</span>
                  </h3>
                </div>
              </div>
            </div>
            <template>
              <div class="row text-center">
                <div class="col-md-4">
                  <img src="/img/pages/fund.png" width="100" alt="..." />
                  <h3 class="mt-2">{{ fund.tag }}</h3>
                  <badge type="info">{{ getTypeLabel(fund.type) }}</badge>
                </div>
                <div class="col-md-8">
                  <div
                    class="card-profile-stats d-flex justify-content-center small pb-0 mb-1 pt-1"
                  >
                    <div>
                      <span class="heading">{{ fund.batches || "-" }}</span>
                      <span class="description">Batches</span>
                    </div>
                    <div>
                      <span class="heading">{{ formatValue(fund.value) }}</span>
                      <span class="description">Valor</span>
                    </div>
                    <div>
                      <span class="heading">{{
                        fund.number_investors || "-"
                      }}</span>
                      <span class="description">Investidores</span>
                    </div>
                  </div>
                  <h4 class="mt-4">
                    <div class="h5 font-weight-300 mb-1">
                      <i class="ni ni-pin-3 mr-2"></i>{{ fund.city || "..." }},
                      {{ fund.state || "..." }}
                    </div>
                  </h4>
                  <h4>
                    Duração:
                    <span class="font-weight-light">
                      {{ formatDate(fund.start_date, "L") || "..." }} até
                      {{ formatDate(fund.end_date, "L") || "..." }}
                    </span>
                  </h4>
                </div>
              </div>
            </template>
            <div slot="footer">
              <base-button
                class="mt-2"
                type="white"
                @click="$router.push(`/admin/fundos/${fund.id}/editar`)"
                ><i class="fas fa-edit text-info mr-2"></i>Editar
                fundo</base-button
              >
            </div>
          </card>
        </div>
      </div>
      <div class="row">
        <div class="col-xl-8">
          <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
              <div class="row align-items-center">
                <div class="col-8">
                  <h3 class="mb-0">Fundo de investimentos</h3>
                </div>
              </div>
            </div>
            <template>
              <form @submit.prevent class="vld-parent" ref="form_container">
                <h6 class="heading-small text-muted mb-4">
                  Metrícas para prestação de contas
                </h6>
                <div class="pl-lg-4">
                  <div class="row">
                    <div class="col-lg-12">
                      <base-input label="Valor total captado">
                        <div class="input-unit-box">
                          <input
                            type="text"
                            placeholder="00,00"
                            class="form-control input-unit"
                            v-model="model.rawNumbers.total_raised"
                            @keypress="ptBrNumber($event)"
                          />
                          <span class="unit">R$ </span>
                        </div>
                      </base-input>
                    </div>
                    <div class="col-lg-12">
                      <base-input label="Valor em caixa">
                        <div class="input-unit-box">
                          <input
                            type="text"
                            placeholder="00,00"
                            class="form-control input-unit"
                            v-model="model.rawNumbers.cash_value"
                            @keypress="ptBrNumber($event)"
                          />
                          <span class="unit">R$ </span>
                        </div>
                      </base-input>
                    </div>
                    <div class="col-lg-12">
                      <base-input label="Investimento total nas startups">
                        <div class="input-unit-box">
                          <input
                            type="text"
                            placeholder="00,00"
                            class="form-control input-unit"
                            v-model="model.rawNumbers.total_investment"
                            @keypress="ptBrNumber($event)"
                          />
                          <span class="unit">R$ </span>
                        </div>
                      </base-input>
                    </div>
                    <div class="col-lg-12">
                      <base-input
                        label="Investimentos nas startups até o momento"
                      >
                        <div class="input-unit-box">
                          <input
                            type="text"
                            placeholder="00,00"
                            class="form-control input-unit"
                            v-model="model.rawNumbers.current_investment"
                            @keypress="ptBrNumber($event)"
                          />
                          <span class="unit">R$ </span>
                        </div>
                      </base-input>
                    </div>
                    <div class="col-12 text-center">
                      <div class="text-sm text-muted mt-2">
                        <i class="fas fa-info-circle text-sm"></i> Os valores
                        devem ser positivos. Utilize vírgula (,) como separador
                        decimal. Ponto (.) não é necessário. Os valores serão
                        formatados para exibição pro investidor.
                      </div>
                    </div>
                    <div class="col-12">
                      <hr class="my-4" />
                      <div class="form-group">
                        <base-input label="Observações">
                          <textarea
                            rows="3"
                            class="form-control form-control"
                            placeholder="Se necessário, digite as observações aqui."
                            v-model="model.metrics.note"
                          >
                          </textarea>
                        </base-input>
                      </div>
                    </div>
                    <div class="col-12">
                      <p class="description text-muted text-right mb-0">
                        Última atualização em
                        {{ formatTimestamp(fund.updated_at) }}.
                      </p>
                    </div>
                  </div>
                </div>
                <hr class="my-4" />
                <div class="col-12 text-center">
                  <base-alert type="danger text-center" v-if="error">
                    {{ error }}
                  </base-alert>
                  <base-button
                    :custom="true"
                    type="primary"
                    @click="handleSubmit"
                    >Salvar métricas</base-button
                  >
                </div>
              </form>
            </template>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/services/api.js";

export default {
  data() {
    return {
      model: {
        metrics: {
          total_raised: "",
          cash_value: "",
          total_investment: "",
          current_investment: "",
          note: "",
        },
        rawNumbers: {
          total_raised: "",
          cash_value: "",
          total_investment: "",
          current_investment: "",
        },
      },
      fund: "",
      error: "",
    };
  },
  async mounted() {
    const loader = this.$loading.show({
      container: this.$refs.form_container,
      width: 90,
      height: 90,
    });
    try {
      const { data } = await api.get(`/funds/${this.$route.params.id}`);
      this.fund = data;
      for (const rawNumber of Object.keys(this.model.rawNumbers)) {
        if (data[rawNumber])
          this.model.rawNumbers[rawNumber] = this.model.metrics[rawNumber] =
            String(data[rawNumber]).replace(/\./g, ",");
      }
      this.model.metrics.note = data.note;
    } catch (e) {
      this.$toasted.error("Ocorreu ao recuperar as informações do fundo");
      this.$router.push("/admin/fundos");
    }
    loader.hide();
  },
  methods: {
    async handleSubmit() {
      this.error = "";
      const numbersMap = {
        total_raised: "Valor total captado",
        cash_value: "Valor em caixa",
        total_investment: "Investimento total nas startups",
        current_investment: "Investimentos nas startups até o momento",
      };
      for (const rawNumber of Object.keys(this.model.rawNumbers)) {
        if (this.model.rawNumbers[rawNumber]) {
          let formattedNumber = "";
          formattedNumber = String(this.model.rawNumbers[rawNumber]).replace(
            /,/g,
            "."
          );
          const validNumber =
            !isNaN(formattedNumber) && isFinite(Number(formattedNumber));
          if (!validNumber) {
            this.error = `Por favor, preencha o campo ${numbersMap[rawNumber]} com um valor númerico válido.`;
            return;
          }
          this.model.metrics[rawNumber] = formattedNumber;
        } else this.model.metrics[rawNumber] = "";
      }

      const loader = this.$loading.show({
        container: this.$refs.form_container,
        width: 90,
        height: 90,
      });
      try {
        await api.put(`/funds/${this.fund.id}`, this.model.metrics);
        this.$toasted.show("Métricas salvas com sucesso");
        this.$router.push("/admin/fundos");
      } catch (e) {
        const strError =
          "Ocorreu um erro ao salvar as métricas. Verifque as informações e tente novamente.";
        const hasErrorMessage =
          e.response && e.response.data && e.response.data.message;
        this.error = hasErrorMessage ? e.response.data.message : strError;
        this.$toasted.error(strError);
      }
      loader.hide();
    },
    ptBrNumber(event) {
      event = event ? event : window.event;
      const key = event.key;
      if (isNaN(key) && key !== ",") event.preventDefault();
      else return true;
    },
    getTypeLabel(fundType) {
      const separator = fundType === "Misto" ? "" : "de";
      return `Fundo ${separator} ${fundType}`;
    },
  },
};
</script>
<style scoped>
.input-unit-box {
  position: relative;
}

.form-control-label-full {
  width: 100%;
}

.input-unit {
  display: block;
  border: 1px solid #d7d6d6;
  background: #fff;
  padding: 10px 10px 10px 30px;
}

.unit {
  position: absolute;
  display: block;
  left: 5px;
  top: 10px;
  z-index: 9;
  color: #444444;
}
</style>
